import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
import { action } from 'satcheljs/lib/legacy';
export default action('showCcWell')(function showCcWell(viewState) {
    if (!viewState.ccRecipientWell) {
        viewState.ccRecipientWell = createRecipientWell(viewState.findPeopleFeedbackManager, [], viewState.toRecipientWell ? viewState.toRecipientWell.contactPicker : undefined);
    }
});
//# sourceMappingURL=showCcWell.js.map